import guards from "../guards.js";
import conditionHelper from "@/helpers/condition";

const load = (page) => {
  return () => import(`@/pages/${page}/${page}.vue`);
};

const nodeEnv =  window.configs && window.configs.NODE_ENV !== "" 
? window.configs.NODE_ENV: process.env.NODE_ENV;

const employeeRoutes = {
  path: "/employee/:company",
  component: () => import(`@/layouts/EmployeeLayout/EmployeeLayout.vue`),
  meta: {
    isCompanySwitchingZone: true,
    zone: "employee",
  },
  beforeEnter: guards.restrictAccesstoUnauthorizedUsers,
  children: [
    {
      name: "employee-root-home",
      path: "",
      component: load("EmployeeHome"),
    },
    {
      name: "employee-home",
      path: "accueil-adv",
      component: load("EmployeeHome"),
    },
    {
      name: "employee-profile",
      path: "profil-adv",
      component: load("Profile"),
    },
    {
      name: "employee-schedule",
      path: "planning",
      component: load("Schedule"),
    },
    {
      name: "employee-schedule-detail",
      path: "planning-detail",
      component: load("ScheduleDetail"),
    },
    {
      name: 'employee-schedule-detail',
      path: 'planning-detail',
      component: load('ScheduleDetail'),
    },
    {
      name: 'employee-schedule-wishes',
      path: 'souhaits-planning',
      component: load('ScheduleWishes'),
    },
    {
      name: 'employee-main',
      path: 'conges',
      component: () => import(`@/layouts/EmployeeLayout/LeaveRequest/leaveRequest.vue`),
      beforeEnter: guards.restrictMandataire,
      children: [
        {
          name: 'employee-leave',
          path: '',
          component: load('Leave'),
          // beforeEnter: function (to, from, next) { nodeEnv !== 'development' ? next('/') : next() },
        },
        {
          name: 'employee-leave-form',
          path: 'form/:type',
          component: load('LeaveRequestForm'),
        },
        {
          name: 'employee-leave-form-edit',
          path: 'form/:type/:id',
          component: load('LeaveRequestForm'),
        },
        {
          name: 'employee-leave-detail',
          path: ':id',
          component: load('LeaveRequestDetail'),
        }
      ]
    },
    {
      name: "employee-missions",
      path: "mes-missions",
      component: load("MyMissions"),
    },
    {
      name: 'employee-support-business',
      path: 'support-business',
      component: load('SupportBusiness'),
      beforeEnter: (to, from, next) => {
        const permission = conditionHelper('rcfbusinesssupport');
        if (permission || permission === undefined) {
          next();
        } else {
          next('/');
        }
      },
    },
    {
      name: 'description-sheet-detail',
      path: 'support-business/:id',
      component: load('DescriptionSheetDetails'),
    },
    {
      name: 'employee-mission',
      path: 'mission-exemple-adv',
      component: load('Mission'),
    },
    {
      name: "employee-mission",
      path: "mission-exemple-adv",
      component: load("Mission"),
    },
    {
      name: "employee-applications",
      path: "candidatures-adv",
      component: load("Applications"),
    },
    {
      name: "employee-agency",
      path: "agence",
      component: () => import(`@/pages/Agency/AgencyContainer.vue`),
    },
    {
      name: "employee-news",
      path: "actualites",
      component: load("News"),
    },
    {
      name: "employee-reclamation",
      path: "reclamation",
      component: load("Reclamation"),
    },
    {
      name: "employee-events",
      path: "evenements",
      component: load("Events"),
    },
    {
      name: 'employee-training',
      path: 'formation',
      component: load('Training'),
      beforeEnter: function (to, from, next) { nodeEnv !== 'development' ? next('/') : next() },
    },
    {
      name: "employee-telemanagement",
      path: "telegestion",
      component: load("Telemanagement"),
    },
    {
      name: 'employee-expense-account',
      path: 'notes-de-frais',
      component: () => import(`@/layouts/EmployeeLayout/expense/ExpenseLayout.vue`),
      beforeEnter: guards.restrictMandataire,
      children: [
        {
          name: 'employee-list',
          path: '',
          component: load('ExpenseAccount'),
          beforeEnter: function (to, from, next) { nodeEnv !== 'development' ? next('/') : next() },
        },
        {
          name: "employee-form",
          path: "form/:type",
          component: load("ExpenseForm"),
        },
        {
          name: "employee-detail",
          path: ":id",
          component: load("ExpenseDetail"),
        },
      ],
    },
    {
      name: "employee-documents",
      path: "documents",
      component: load("Documents"),
    },
    {
      name: "employee-assignment-offer",
      path: "assignment-offers",
      component: load("AssignmentOffers"),
      beforeEnter: function(to, from, next) {
        nodeEnv !== "development" ? next("/") : next();
      },
    },
    {
      name: "employee-assignment-offer-detail",
      path: "assignment-offers-detail",
      component: load("AssignmentOfferDetail"),
    },
    {
      name: "employee-support-technique",
      path: "support-technique",
      component: load("SupportTechnique"),
    },
    {
      name: 'employee-message',
      path: 'messages',
      meta: {
        multiConditions: ['rcfchatadvagency', 'rcfchatadvteam', 'rcfchatadvteamclient']
      },
      component: load('Message'),
      // beforeEnter: function (to, from, next) { nodeEnv !== 'development' ? next('/') : next() },
      children: [
        {
          name: 'employee-message-details',
          path: ':id',
          component: load('MessageDetails'),
        }
      ]
    },
    {
      name: 'employee-assignment-offer',
      path: 'assignment-offers',
      component: load('AssignmentOffers'),
      beforeEnter: function (to, from, next) { nodeEnv !== 'development' ? next('/') : next() },
    },
    {
      name: 'employee-assignment-offer-detail',
      path: 'assignment-offers-detail',
      component: load('AssignmentOfferDetail'),
    },
    {
      name: 'employee-support-technique',
      path: 'support-technique',
      component: load('SupportTechnique'),
    },
    {
      name: 'employee-classification',
      path: 'classification',
      component: load('Classification'),
    },
    {
      name: 'employee-my-contract',
      path: 'mon-contrat',
      component: load('MyContracts'),
    },
    {
      name: 'employee-support',
      path: 'support/:keyword',
      component: load('SupportPsySocial'),
      beforeEnter: (to, from, next) => {
        const permission = conditionHelper(`rcf${to.params.keyword.toLowerCase()}`);
        if (permission || permission === undefined) {
          next();
        } else {
          next('/');
        }
      },
    },
    {
      name: 'employee-notifications',
      path: 'notifications',
      component: load('Notifications'),
    },
  ],
};

export default employeeRoutes;
